import axios from 'axios';

export const OsApi = {
    list: () => axios.get('/web/service-order/'),
    create: (osData) => axios.post('/web/service-order/', osData),
    update: (id, osData) => axios.put(`/web/service-order/${id}/`, osData),
    userList: () => axios.get('/web/company-users/'),
    equipmentsList: () => axios.get('/web/equipments/')
};
